export const th = {
  searchPlaceholder: 'ค้นหา...',
  resultsTitle: 'ผลการค้นหา',
  typeToSearch: 'ค้นหาด้วยทะเบียนรถ ชื่อตัวแทน เลขกรมธรรม์ หรือเลขคำสั่งซื้อ',
  noData: 'ไม่พบข้อมูลสำหรับคำค้นหานี้',
  clear: 'ล้าง',
  close: 'ปิดผลการค้นหา',
  viewDetails: 'ดูรายละเอียด',
  platformOrders: 'คำสั่งซื้อแพลตฟอร์ม',
  expandSearch: 'ขยายช่องค้นหา',
};
